__turbopack_context__.v({
  "codeBlock": "rhythmguard-module__U7qZGG__codeBlock",
  "metaBlock": "rhythmguard-module__U7qZGG__metaBlock",
  "metaGrid": "rhythmguard-module__U7qZGG__metaGrid",
  "metaLabel": "rhythmguard-module__U7qZGG__metaLabel",
  "metaLeft": "rhythmguard-module__U7qZGG__metaLeft",
  "metaOverview": "rhythmguard-module__U7qZGG__metaOverview",
  "metaRight": "rhythmguard-module__U7qZGG__metaRight",
  "metaSection": "rhythmguard-module__U7qZGG__metaSection",
  "metaText": "rhythmguard-module__U7qZGG__metaText",
  "metaTools": "rhythmguard-module__U7qZGG__metaTools",
  "page": "rhythmguard-module__U7qZGG__page",
});
